export const SET_ADMIN_STATE = 'SET_ADMIN_STATE';
export const SET_SITES = 'SET_SITES';
export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
